import styled from '@emotion/styled';
import PropTypes from 'prop-types';
import CircularProgress from '@material-ui/core/CircularProgress';
import UnfilledCircle from './UnfilledCircle';

const StyledCircularProgress = styled(CircularProgress)`
  color: ${({ $customColor }) => $customColor};
`;

const Wrapper = styled.div`
  position: relative;
`;

const SIZE = 44;

const CircularProgressBar = ({
  color,
  size,
  className,
  thickness,
  value,
  unfilledColor
}) => {
  return (
    <Wrapper className={className}>
      <UnfilledCircle
        circleDiameter={SIZE}
        color={unfilledColor}
        size={size}
        thickness={thickness}
      />
      <StyledCircularProgress
        $customColor={color}
        size={size}
        thickness={thickness}
        value={value}
        variant="determinate"
      />
    </Wrapper>
  );
};

CircularProgressBar.propTypes = {
  color: PropTypes.string,
  size: PropTypes.number,
  className: PropTypes.string,
  thickness: PropTypes.number,
  value: PropTypes.number,
  unfilledColor: PropTypes.string
};

CircularProgressBar.defaultProps = {
  color: 'var(--color-i-green)',
  size: 40,
  className: '',
  thickness: 3.6,
  value: 0,
  unfilledColor: 'var(--color-i-blue)'
};

export default CircularProgressBar;
